const cardManagementModule = {
  namespaced: true,
  state: {
    cardForm: [
      {
        label: '卡號',
        prop: 'cardNumber',
        type: 'input',
        required: true
      },
      {
        label: '設備權限',
        prop: 'deviceRight',
        type: 'upload',
        required: true
      },
      {
        label: '棟別',
        prop: 'building',
        type: 'select',
        required: true
      },
      {
        label: '樓層',
        prop: 'floor',
        type: 'select',
        required: true
      },
      {
        label: '戶別',
        prop: 'household',
        type: 'select',
        required: true
      }
    ],
    cardInfo: {
      cardNumber: { value: '' },
      deviceRight: { value: '' },
      building: {
        options: Array.from({ length: 4 }).map((_, index) => ({
          value: String.fromCharCode(65 + index),
          label: `${String.fromCharCode(65 + index)}棟`
        })),
        value: ''
      },
      floor: {
        options: Array.from({ length: 4 }).map((_, index) => ({
          label: `${index + 1}F`,
          value: `${index + 1}F`
        })),
        value: ''
      },
      household: {
        options: Array.from({ length: 4 }).map(() => ({
          label: Math.floor(Math.random() * 900) + 100,
          value: Math.floor(Math.random() * 900) + 100
        })),
        value: ''
      }
    }
  },
  getters: {
    getCardForm: (state) => state.cardForm,
    getCardInfo: (state) => state.cardInfo
  },
  mutations: {
    UPDATE_OPERATE_DATA(state, { cardInfo }) {
      state.cardInfo.cardNumber.value = cardInfo.cardNumber
      // state.cardInfo.deviceRight.value = cardInfo.deviceRight
      state.cardInfo.building.value = cardInfo.building
      state.cardInfo.floor.value = cardInfo.floor
      state.cardInfo.household.value = cardInfo.household
    }
  },
  actions: {
    UPDATE_OPERATE_DATA({ commit }, payload) {
      const { cardInfo } = payload
      commit('UPDATE_OPERATE_DATA', { cardInfo })
    }
  }
}

export default cardManagementModule
